import React from 'react';
import component, {classnames} from './../component';
import Flag from './../Flag';
import Link from './../Link';
import _ from 'lodash';

import {getRandomInt, randomString} from './../randomizer.js';

import TournamentDetails from './TournamentDetails';

import {summGameResults} from './../GamesItem.js';

const SubWinners = component('SubWinners', function(props){
  return (
    <div className="PlayOff-GridRoundGameSubWinners">
      <div className={classnames(
        "PlayOff-GridRoundGameTeamsTeam",
        props.round.winners[1] && "PlayOff-GridRoundGameTeamsTeam--Winner"
      )}>
        <span className="PlayOff-GridRoundGameTeamsTeamName">
          {props.round.winners[1] &&
            <Link name="teamDetails" params={{id: props.round.winners[1].id}}>
              {props.round.winners[1].country && <Flag country={props.round.winners[1].country}/>}
              {props.round.winners[1].title}
            </Link> ||
            <span>&nbsp;</span>
          }
          <span className="PlayOff-WinnerPlace">Второе место</span>
        </span>
      </div>
      {(props.round.hasHalfFinalGame || props.round.winners[2]) &&
        <div className={classnames(
          "PlayOff-GridRoundGameTeamsTeam",
          props.round.halfFinal.results && props.round.halfFinal.results.length && "PlayOff-GridRoundGameTeamsTeam--Winner"
        )}>
          <span className={classnames(
            "PlayOff-GridRoundGameTeamsTeamName",
            props.round.halfFinal.results && !props.round.halfFinal.results.length && "PlayOff-GridRoundGameTeamsTeamName-noResult"
          )}>
            {props.round.winners[2] &&
              <Link name="teamDetails" params={{id: props.round.winners[2].id}}>
                {props.round.winners[2].country && <Flag country={props.round.winners[2].country}/>}
                {props.round.winners[2].title}
              </Link> ||
              <span>&nbsp;</span>
            }
            <span className="PlayOff-WinnerPlace">Третье место</span>
          </span>
        </div>
      }
      {
        props.round.hasHalfFinalGame && (
          props.round.halfFinal &&
            <Link className="PlayOff-GridRoundGameResult" name="gameDetails" params={{id: props.round.halfFinal.game.games[0].id}}>
              {props.round.halfFinal && props.round.halfFinal.results &&
                (props.round.halfFinal.results.length ? props.round.halfFinal.results[0]+':'+props.round.halfFinal.results[1] : '—:—')
              }
              {props.round.halfFinal.results && !props.round.halfFinal.results.length &&
                <span className="PlayOff-GridRoundGameResultHint">Ожидается матч за третье место</span> ||
                <span className="PlayOff-GridRoundGameResultHint">Матч за третье место</span>
              }
            </Link> ||
            <div className="PlayOff-GridRoundGameResult">
              <span className="PlayOff-GridRoundGameResultHint">Матч за третье место</span>
            </div>
        )
      }
      {(props.round.hasHalfFinalGame || props.round.winners[3]) &&
        <div className="PlayOff-GridRoundGameTeamsTeam">
          <span className={classnames(
            "PlayOff-GridRoundGameTeamsTeamName",
            props.round.halfFinal.results && !props.round.halfFinal.results.length && "PlayOff-GridRoundGameTeamsTeamName-noResult"
          )}>
            {props.round.winners[3] &&
            <Link name="teamDetails" params={{id: props.round.winners[3].id}}>
              {props.round.winners[3].country && <Flag country={props.round.winners[3].country}/>}
              {props.round.winners[3].title}
            </Link> ||
            <span>&nbsp;</span>
            }
            {props.round.halfFinal.results && props.round.halfFinal.results.length &&
              <span className="PlayOff-WinnerPlace">Четвертое место</span> || null
            }
          </span>
        </div>
      }
    </div>
  );
});

const TeamName = component('TeamName', function({team, isWinner}){
  return (
    <span className="PlayOff-GridRoundGameTeamsTeamName">
      {team &&
      <Link name="teamDetails" params={{id: team.id}}>
        {team.country && <Flag country={team.country}/>}
        {team.title}
      </Link> ||
      <span>&nbsp;</span>
      }
      {isWinner && <span className="PlayOff-WinnerPlace">Победитель</span>}
    </span>
  );
});

const Game = component('Game', function(props){
  const results = summGameResults(props.game.results);
  const winnerPic = props.round.winnerPic ?
                    `${props.round.winnerPic}?crop=1&w=80&h=80`
                    :
                    require('../../img/teamEmptyAvatarSquare.png');
  return (
    <div className={classnames(
      'PlayOff-GridRoundGame',
      props.round.onlyResults && 'PlayOff-GridRoundResume',
      (props.round.markWinner || props.round.hasHalfFinalGame) && 'PlayOff-GridRoundResume--Winner'
    )}>
      <div className="PlayOff-GridRoundGameTeams">
        <div className={classnames('PlayOff-GridRoundGameTeamsTeam', results[0] > results[1] && 'PlayOff-GridRoundGameTeamsTeam--Winner')}>
          {props.round.onlyResults && props.round.markWinner &&
            <div className="PlayOff-GridRoundGameTeamsTeamWinnerLogo"
                 style={{backgroundImage: `url(${winnerPic})`}} />
          }
          <TeamName team={props.game.team_a} isWinner={props.round.markWinner || props.round.hasHalfFinalGame}/>
          {
            (props.round.markWinner || props.round.hasHalfFinalGame) &&
            <SubWinners round={props.round}/>
          }
        </div>
        {!props.round.onlyResults &&
          <div className={classnames('PlayOff-GridRoundGameTeamsTeam', results[0] < results[1] && 'PlayOff-GridRoundGameTeamsTeam--Winner')}>
            <TeamName team={props.game.team_b}/>
          </div>
        }
      </div>
      {!props.round.onlyResults &&
          <Link className="PlayOff-GridRoundGameResult" name="gameDetails" params={{id: props.game.id}}>
            {props.game.results.length ? (results[0]+':'+results[1]) : props.game.team_a && props.game.team_b ? '—:—' : ' '}
          </Link>
      }
    </div>
  );
});

const Round = component('Round', function(props){
  let result = [];
  props.round.games.forEach((game, i) => {
    result.push(<Game
      game={game}
      round={props.round}
      key={'game'+i}/>);
  });
  let height = props.height;

  return (
    <div style={{height}} className={classnames('PlayOff-GridRound', props.round._hasInjectedTeams && 'PlayOff-GridRound--HasInjectedTeams', props.round._nextRoundHasInjectedTeams && 'PlayOff-GridRound--NextRoundHasInjectedTeams')}>
      {result.map((game)=>(game))}
    </div>
  );
});

const PlayOff = component('PlayOff', function(props){
  let shownRounds = [];

  for(var i = props.state.selectedRound.number; i<props.state.selectedRound.number+ props.state.roundsOnPage; i++){
    let height = 'auto';
    if(i === props.state.selectedRound.number){
      height = props.state.rounds[props.state.selectedRound.number-1].games.length * 182 - 34 +'px'; // fix for Opera 12.1x
    }
    shownRounds.push(<Round height={height} round={props.state.rounds[i-1]} key={'round'+i}/>);
    if(props.state.rounds[i-1].markWinner || props.state.rounds[i-1].hasHalfFinalGame){
      var containsWinners = true;
    }
  }

  return (
    <div className={classnames('PlayOff-Grid', containsWinners && 'PlayOff-Grid--ContainsWinners')}>
      {shownRounds.map((round)=>(round))}
    </div>
  );
});

const PlayOffControl = component('PlayOffControl', function(props){
  let trigger = () => {
    props.trigger(props.round.number-1);
  };

  return (
    <div
      className={classnames('PlayOff-ControlItem', props.active && 'PlayOff-ControlItemActive', props.active && 'PlayOff-ControlItemActive'+ (props.active === 1 ? 'Left' : (props.active === props.state.roundsOnPage ? 'Right' : 'Middle')))}
      onClick={trigger}
      >{!props.round.onlyResults && '1/'+props.round.games.length*2 || 'Финал'}</div>
  );
});

const PlayOffControls = component('PlayOffControls', function(props){
  return (
    <div className="PlayOff-Control">
      {props.state.rounds.map((round) => {
        return <PlayOffControl key={'control'+round.number} {...props} trigger={props.trigger} round={round} active={round.number >= props.state.selectedRound.number && round.number < props.state.selectedRound.number+props.state.roundsOnPage && round.number-props.state.selectedRound.number+1 || false }/>
      })}
    </div>
  );
});


const SingleGameType = {
  top: 1,
  final: 2,
  halfFinal: 3
};



export default component('TournamentPlayOff', {

  _getGrid(props){
    if(!props){
      props = this.props;
    }
    let rounds = (
      props.hasOwnProperty('losers') ?
        props['losers'] ?
          props.stage.get('bottom_rounds') :
          props.stage.get('top_rounds')
        :
        props.stage.get('rounds')
    );

    rounds = rounds.toJS();
    let singleHalfFinal = null;


    if( props.hasOwnProperty('losers') ) {
      rounds.forEach((round, index) => {
        if (index > 0 && rounds[index - 1].games.length === round.games.length) {
          round._hasInjectedTeams = true;
          if (!props['losers']) {
            rounds[index - 1]._nextRoundHasInjectedTeams = true; // injecting player into non-losers grid needs additional styling
          }
        }
      });
    }else{
      rounds = rounds.filter((round)=>{
        if(round.type !== SingleGameType.halfFinal){
          return true;
        }else{
          singleHalfFinal = round;
          return false;
        }
      })
    }

    const lastRound = rounds[rounds.length-1];
    let resultsRound = {};
    resultsRound.games = [];
    if(lastRound.games.length === 1) {
      resultsRound.winners = new Array(4);
    }
    lastRound.games.forEach((game) => { // always only one game
      const results = summGameResults(game.results);
      if(resultsRound.hasOwnProperty('winners')) {
        if (results[0] > results[1]) {
          resultsRound.winners[0] = game.team_a;
          resultsRound.winners[1] = game.team_b;
        } else if (results[0] < results[1]) {
          resultsRound.winners[0] = game.team_b;
          resultsRound.winners[1] = game.team_a;
        }
      }
      resultsRound.games.push({
        team_a: results[0] > results[1] ? game.team_a : results[1] > results[0] ? game.team_b : null,
        team_b: null,
        id: null,
        results: [],
        status: null
      });
    });
    resultsRound.number = lastRound.number+1;
    resultsRound.id = null;
    resultsRound.onlyResults = true;
    resultsRound.markWinner = resultsRound.winners && resultsRound.winners[0] && !props['losers'];


    const tournament = props.data.getIn(['tournamentData', parseInt(props.params.id)]);
    resultsRound.winnerPic = tournament && tournament.get('winner_pic') || '';


    if(props.hasOwnProperty('losers') && !props['losers']){
      const bottomRounds = props.stage.get('bottom_rounds').toJS();
      let third = bottomRounds[bottomRounds.length-1];
      let thirdResults;
      if(third) {
        thirdResults = summGameResults(third.games[0].results);
      }
      let fourth = bottomRounds[bottomRounds.length-2];
      let fourthResults;
      if(fourth) {
        fourthResults = summGameResults(fourth.games[0].results);
      }

      if(thirdResults && fourthResults) {
        resultsRound.winners[2] = thirdResults[0] > thirdResults[1] ? third.games[0].team_b : third.games[0].team_a;
        resultsRound.winners[3] = fourthResults[0] > fourthResults[1] ? fourth.games[0].team_b : fourth.games[0].team_a;
      }
    }
    if(!props.hasOwnProperty('losers') && singleHalfFinal){
      const halfFinalResults = summGameResults(singleHalfFinal.games[0].results);
      if(halfFinalResults[0] > halfFinalResults[1]){
        resultsRound.winners[2] = singleHalfFinal.games[0].team_a;
        resultsRound.winners[3] = singleHalfFinal.games[0].team_b;
        resultsRound.halfFinal = {
          game: singleHalfFinal,
          results: [halfFinalResults[0], halfFinalResults[1]]
        };
      }else if(halfFinalResults[1] > halfFinalResults[0]){
        resultsRound.winners[2] = singleHalfFinal.games[0].team_b;
        resultsRound.winners[3] = singleHalfFinal.games[0].team_a;
        resultsRound.halfFinal = {
          game: singleHalfFinal,
          results: [halfFinalResults[1], halfFinalResults[0]]
        };
      } else { // non-played yet half-final
        const players = _.sortBy([singleHalfFinal.games[0].team_a, singleHalfFinal.games[0].team_b], 'title');
        resultsRound.winners[2] = players[0];
        resultsRound.winners[3] = players[1];
        resultsRound.halfFinal = {
          game: singleHalfFinal,
          results: []
        };
      }
    }
    resultsRound.hasHalfFinalGame = !!resultsRound.halfFinal;

    rounds.push(resultsRound);


    return {
      rounds: rounds,
      roundsOnPage: rounds.length > 4 ? 4 : rounds.length,
      selectedRound: rounds && rounds[0] || {}
    }
  },

  getInitialState() {
    return this._getGrid();
  },

  componentWillReceiveProps(newProps){
    this.setState(this._getGrid(newProps));
  },

  _trigger(index){
    this.setState({
      selectedRound: this.state.rounds[
        this.state.rounds.length - this.state.roundsOnPage > index ?
          index :
          this.state.rounds.length - this.state.roundsOnPage
      ]
    });
  },


  render() {
    if(!this.state.rounds){
      return null;
    }

    return (
      <div className={classnames('PlayOff', this.state.selectedRound.number === 1 && 'PlayOff--FirstIteration', this.props.hasOwnProperty('losers') && 'PlayOff--Double', this.props['losers'] && 'PlayOff--Losers')}>
        <div className="PlayOff-Header">
          <h1>Стадия Плей-офф</h1>
          {this.props.hasOwnProperty('losers') &&
          <div className="PlayOff-HeaderSwitch SubNav">
            <div className="SubNav-Item">
              <Link name="tournamentStage" params={{id: this.props.params.id, stageId: this.props.params.stageId}} keepScroll={true}>Винеры</Link>
            </div>
            <div className="SubNav-Item">
              <Link name="tournamentStageInner" params={{id: this.props.params.id, stageId: this.props.params.stageId, modificator: 'losers'}} keepScroll={true}>Лузеры</Link>
            </div>
          </div>
          }
        </div>
        <PlayOffControls trigger={this._trigger} state={this.state}/>
        <PlayOff state={this.state}/>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/pages/TournamentPlayOff.js